import React from 'react';
import { Helmet } from '@plone/volto/helpers';

import config from '@plone/volto/registry';

const Favicon = () => {
  return config.settings.iovisit.favicon ? (
    <Helmet>
      {config.settings.iovisit.favicon.map((fav, i) => (
        <link {...fav} key={i} />
      ))}
    </Helmet>
  ) : (
    <></>
  );
};

export default Favicon;
